import { request } from "../../api/api";

export const getReport = (params) => {
  return request.post(`getReport/`, params);
};

export const updateReportStatus = (params) => {
  return request.post(`updateReportStatus/`, params);
};
export const getElectricRevision = (params) => {
  return request.post(`getElectricRevision/`, params);
};
export const exportElectricExcel = (params) => {
  return request.post(`/exportElectricTest/`, params);
};
export const exportVisualExcel = (params) => {
  return request.post(`/exportVisualInspection/`, params);
};
export const exportFinalVisualExcel = (params) => {
  return request.post(`exportFinalVisualInspection/`, params);
};

export const updateFinalVisualInspectionData = (params) => {
  return request.post(`updateFinalVisualInspectionData/`, params);
};

export const getelectricdata = (params) => {
  return request.get(
    `/getelectricdata/?search=${params.searchText.B_No}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}&created_at__date=${
      params.searchText.Date
    }&uid__uid_id_type=${
      params.searchText.UID
    }&electric_test_details__tested_shift__shift_name=${
      params.searchText.Shift
    }&batch__lot_number=${
      params.searchText.Lot_No
    }&batch__class_id__class_name=${
      params.searchText.Class
    }&batch__size__size_name=${params.searchText.Size}&thickness=${
      params.searchText.Thickness
    }&electric_test_details__revision_count=${
      params.searchText.electric_test_count
    }&start_datetime=${params.startDateTime}&end_datetime=${
      params.endDateTime
    }&electric_test_details__modified_at__date=${
      params.searchText.Test_date
    }&electric_test=${
      params.searchText.Test_Result == "pass"
        ? true
        : params.searchText.Test_Result == "fail"
        ? false
        : ""
    }&r_or_l=${
      params.searchText.RorL
        ? params.searchText.RorL
        : params.selectRorL == "all"
        ? ""
        : params.selectRorL
    }`
  );
};
export const getfvidata = (params) => {
  return request.get(
    `getfvidata/?search=${params.searchText.B_No}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}&created_at__date=${
      params.searchText.Date
    }&uid__uid_id_type=${
      params.searchText.UID
    }&final_visual_inspection_details__tested_shift__shift_name=${
      params.searchText.Shift
    }&batch__lot_number=${
      params.searchText.Lot_No
    }&batch__class_id__class_name=${
      params.searchText.Class
    }&batch__size__size_name=${params.searchText.Size}&thickness=${
      params.searchText.Thickness
    }&uid__approval_status_fvi=${
      params.searchText.Approval_Status
    }&final_visual_inspection_details__modified_at__date=${
      params.searchText.Test_date
    }&start_datetime=${params.startDateTime}&end_datetime=${
      params.endDateTime
    }&final_visual_inspection=${
      params.searchText.Test_Result == "pass"
        ? true
        : params.searchText.Test_Result == "fail"
        ? false
        : ""
    }&r_or_l=${
      params.searchText.RorL
        ? params.searchText.RorL
        : params.selectRorL == "all"
        ? ""
        : params.selectRorL
    }`
  );
};

export const getqrprintingdata = (params) => {
  console.log(".........................", params);
  return request.get(
    `/getqrprintingdata/?search=${params.searchText.B_No}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}&created_at__date=${
      params.searchText.Date
    }&uid__uid_id_type=${params.searchText.UID}&qr_printing_tested_date__date=${
      params.searchText.Test_date
    }&qr_printing_tested_shift__shift_name=${
      params.searchText.Shift
    }&batch__lot_number=${
      params.searchText.Lot_No
    }&batch__class_id__class_name=${
      params.searchText.Class
    }&batch__size__size_name=${params.searchText.Size}&thickness=${
      params.searchText.Thickness
    }&start_datetime=${params.startDateTime}&end_datetime=${
      params.endDateTime
    }&qr_printing=${
      params.searchText.Print_Result == "pass"
        ? true
        : params.searchText.Print_Result == "fail"
        ? false
        : ""
    }&r_or_l=${
      params.searchText.RorL
        ? params.searchText.RorL
        : params.selectRorL == "all"
        ? ""
        : params.selectRorL
    }`
  );
};

export const getfvidetaildata = (params) => {
  return request.post(`/getfvidetail/`, params);
};

export const getprintingdata = (pageparams) => {
  return request.get(
    `/getprintingdata/?search=${pageparams.searchText.B_No}&page=${
      pageparams.page + 1
    }&page_size=${pageparams.rowsPerPage}&uid__uid_id_type=${
      pageparams.searchText.UID
    }&batch__class_id__class_name=${
      pageparams.searchText.Class
    }&batch__size__size_name=${
      pageparams.searchText.Size
    }&uid_tested_shift__shift_name=${
      pageparams.searchText.Shift
    }&batch__lot_number=${pageparams.searchText.Lot_No}&created_at__date=${
      pageparams.searchText.Date
    }&start_datetime=${pageparams.startDateTime}&end_datetime=${
      pageparams.endDateTime
    }&uid_printing_tested_date__date=${
      pageparams.searchText.Test_Date
    }&uid_printing=${
      pageparams.searchText.Print_Result == "pass"
        ? true
        : pageparams.searchText.Print_Result == "fail"
        ? false
        : ""
    }&r_or_l=${
      pageparams.searchText.RorL
        ? pageparams.searchText.RorL
        : pageparams.selectRorL == "all"
        ? ""
        : pageparams.selectRorL
    }&thickness=${pageparams.searchText.Thickness}`
  );
};

export const getVisualInspectionData = (params) => {
  return request.get(
    `getVisualInspectionData/?search=${params.searchText.B_No}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}&uid__uid_id_type=${
      params.searchText.UID
    }&batch__class_id__class_name=${
      params.searchText.Class
    }&batch__size__size_name=${
      params.searchText.Size
    }&visual_inspection_details__tested_shift__shift_name=${
      params.searchText.Shift
    }&batch__lot_number=${params.searchText.Lot_No}&thickness=${
      params.searchText.Thickness
    }&created_at__date=${
      params.searchText.Date
    }&visual_inspection_details__created_at__date=${
      params.searchText.Test_date
    }&start_datetime=${params.startDateTime}&end_datetime=${
      params.endDateTime
    }&visual_inspection=${
      params.searchText.Print_Result == "pass"
        ? true
        : params.searchText.Print_Result == "fail"
        ? false
        : ""
    }&r_or_l=${
      params.searchText.RorL
        ? params.searchText.RorL
        : params.selectRorL == "all"
        ? ""
        : params.selectRorL
    }&batch__approval_status_visual_inspection=${
      params.searchText.Approve_status
    }`
  );
};

export const exportVisualInspection = (params) => {
  return request.post(`/exportVisualInspection/`, params);
};

export const getTopCount = (params) => {
  return request.post(`/GetTopCount/`, params);
};

export const exportVisualInspectionExcel = (params) => {
  return request.post(`/exportVisualInspectionExcel/`, params);
};

export const getProductionLineStrippingDataP2 = (params) => {
  return request.get(
    `/getProductionLineStrippingDataP2/?page=${params.page + 1}&page_size=${
      params.rowsPerPage
    }`
  );
};
export const getOutFeedVisualInspectionP2 = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/getOutFeedVisualInspectionP2/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};

export const getProductionLineLeachingDataP2 = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/getProductionLineLeachingDataP2/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};
export const getTunnelOvenDataWithLeachingP2 = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/getTunnelOvenDataWithLeachingP2/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};
export const getProductionLineStaticLeachingDataP2 = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/getProductionLineStaticLeachingDataP2/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};
export const getProductionLineWashingMachine1DataP2 = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/getProductionLineWashingMachine1DataP2/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};
export const getProductionLineWashingMachine2DataP2 = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/getProductionLineWashingMachine2DataP2/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};
export const getAllUltrasonicRFIDData = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.Rfid
      ? `rfid_tag__icontains=${params.searchText.Rfid}`
      : "",
      params.searchText.time
      ? `created_at=${params.searchText.time}`
      : "",
    params.searchText.shift
      ? `shift__shift_name__icontains=${params.searchText.shift}`
      : "",
    params.searchText.ultraSonicTank
      ? `ultrasonic_t_time__icontains=${params.searchText.ultraSonicTank}`
      : "",
    params.searchText.rinsingTank
      ? `rinsing_t_time__icontains=${params.searchText.rinsingTank}`
      : "",
    params.searchText.OvenTankTime
      ? `oven_tank_time=${params.searchText.OvenTankTime}`
      : "",
      params.start_datetime
      ? `start_datetime=${params.start_datetime}`
      : "",
    params.end_datetime
      ? `end_datetime=${params.end_datetime}`
      : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getAllUltrasonicRFIDData/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};
export const getTumbleDryingDataList = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getTumbleDryingDataList/?dryer_name=${"TD1"}&${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};

export const getTumbleDryingDataList2 = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getTumbleDryingDataList/?dryer_name=${"TD2"}&${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};
export const getProngOvenDataList = (params, value) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getProngOvenDataList/?oven_name=${
      value == 10
        ? "PO1"
        : value == 15
        ? "PO2"
        : value == 19
        ? "PO3"
        : value == 22
        ? "PO4"
        : ""
    }&${queryParams}&page=${params.page + 1}&page_size=${params.rowsPerPage}`
  );
};
export const getAutoclaveDataList = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getAutoclaveDataList/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};
export const getCuttingDetails = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getCuttingDataList/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};

export const getACConditioningDataList = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getACConditioningDataList/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};

export const getHancoWashingDataList = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getHancoWashingDataList/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};

export const getChlorinationDataList = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getChlorinationDataList/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};

export const getExtraACConditioningDataList = (params) => {
  let queryParams = [
    params.searchText.date ? `search=${params.searchText.date}` : "",
    params.searchText.bNo ? `batch__batch_type=${params.searchText.bNo}` : "",
    params.searchText.shift
      ? `shift__shift_name=${params.searchText.shift}`
      : "",
    params.searchText.startTime
      ? `cycle_start_time=${params.searchText.startTime}`
      : "",
    params.searchText.endTime
      ? `cycle_end_time=${params.searchText.endTime}`
      : "",
    params.searchText.lotNo
      ? `batch__lot_number=${params.searchText.lotNo}`
      : "",
    params.searchText.class
      ? `batch__class_id__class_name=${params.searchText.class}`
      : "",
    params.searchText.size
      ? `batch__size__size_name=${params.searchText.size}`
      : "",
    params.searchText.thickness
      ? `batch__thickness=${params.searchText.thickness}`
      : "",
    params.searchText.good ? `good=${params.searchText.good}` : "",
    params.searchText.reject ? `reject=${params.searchText.reject}` : "",
    params.searchText.hold ? `hold=${params.searchText.hold}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getExtraACConditioningDataList/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );
};

export const getOutFeedVisualInspectionDefectDetails = (id) => {
  return request.get(
    `/reports_approval/getOutFeedVisualInspectionDefectDetails/?batch_id=${id}`
  );
};
export const getAllDippingCellData = (params) => {
  console.log("paramsparamsparams",params)
  let queryParams = [
    params.searchText.date ? `date=${params.searchText.date}` : "",
    params.searchText.shift ? `shift=${params.searchText.shift}` : "",
    params.searchText.time
      ? `time=${params.searchText.time}`
      : "",
    params.searchText.parameter_type
      ? `parameter_type=${params.searchText.parameter_type}`
      : "",
    params.searchText.d_m_tanks
      ? `d_m_tanks=${params.searchText.d_m_tanks}`
      : "",
    params.searchText.lot_no
      ? `lot_no=${params.searchText.lot_no}`
      : "",
    params.searchText.temp
      ? `temp=${params.searchText.temp}`
      : "",
    params.searchText.ph
      ? `ph=${params.searchText.ph}`
      : "",
    params.searchText.viscosity
      ? `viscosity=${params.searchText.viscosity}`
      : "",
    params.searchText.maturation ? `maturation=${params.searchText.maturation}` : "",
    params.searchText.specific_gravity ? `specific_gravity=${params.searchText.specific_gravity}` : "",
    params.searchText.foam_test_1 ? `foam_test_1=${params.searchText.foam_test_1}` : "",
    params.searchText.foam_test_2 ? `foam_test_2=${params.searchText.foam_test_2}` : "",
    params.searchText.foam_test_3 ? `foam_test_3=${params.searchText.foam_test_3}` : "",
    params.searchText.remark_time ? `remark_time=${params.searchText.remark_time}` : "",
    params.searchText.plate_test ? `plate_test=${params.searchText.plate_test}` : "",
    params.searchText.repeated_reading ? `repeated_reading=${params.searchText.repeated_reading}` : "",
    params.searchText.hot_conductivity ? `hot_conductivity=${params.searchText.hot_conductivity}` : "",
    params.searchText.cold_conductivity ? `cold_conductivity=${params.searchText.cold_conductivity}` : "",
    params.searchText.operator_name ? `operator_name=${params.searchText.operator_name}` : "",
    params.searchText.supervisor_name ? `supervisor_name=${params.searchText.supervisor_name}` : "",
    params.start_datetime ? `start_datetime=${params.start_datetime}` : "",
    params.end_datetime ? `end_datetime=${params.end_datetime}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/reports_approval/getAllDippingCellData/?${queryParams}&page=${
      params.page + 1
    }&page_size=${params.rowsPerPage}`
  );

};
export const getDippingCellPopupData = (data) => {
  return request.post(
    `/reports_approval/getDippingCellPopupData/`,data
  );
};